import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { Link } from 'react-router'
import classNames from 'classnames'
import { Gates } from 'utils/Access'
import defaultAppIconSrc from 'images/svg/default-app-icon.svg'
import style from 'styles/components/integrations/IntegrationCard.styl'
import { defaultTo } from 'ramda'
import { api } from 'components/Integration/pages/CommonIntegrationPage/api.js'
import { Icon } from '@driftt/tide-core-legacy'


const orDefaultIconSrc = (src) => defaultTo(defaultAppIconSrc)(src)

const Active = (
  <div className="active-integration">
    <img src={require('images/svg/check-circle-green.svg')} style={{ width: 15, height: 15 }} />
    Connected
  </div>
)

const Incomplete = (
  <div className="incomplete-integration">
    <Icon name="warning-triangle" style={{ width: 15, height: 15 }} />
    Incomplete
  </div>
)


const AnchorLink = ({ url, children }) => (
  <a href={url} target="_blank">
    {children}
  </a>
)

class IntegrationCard extends Component {

  constructor(props) {
    super(props)

    this.state = {
      isIntegrationStarted: false
    }

    if (props.incompleteInstallEndpoint) {
      this.getIncompleteInstallStatus()
    }
  }

  getIncompleteInstallStatus = () => {
    api.integrationAPICall(this.props.incompleteInstallEndpoint).then(res => {
      this.setState({
        isIntegrationStarted: res.installed
      })
    })
  }

  renderDetails = () => {
    const {
      title,
      description,
      logoSrc,
      isActive,
      hasAccess,
      isGatedByPlan,
      upgradeRibbonText,
      detail = 'View Details',
      incompleteInstallEndpoint
    } = this.props

    const {
      isIntegrationStarted
    } = this.state

    const isIncomplete = incompleteInstallEndpoint && ((!isActive && isIntegrationStarted) || (isActive && !isIntegrationStarted))
    const detailComponent = (isIncomplete && Incomplete) || (isActive && Active) || (hasAccess ? 'View Details' : detail)
    const ribbonText = !hasAccess && isGatedByPlan ? upgradeRibbonText : false

    return (
      <div className={classNames(style.IntegrationCard, { disabled: !hasAccess })}>
        {ribbonText &&
          <span className="upgrade-ribbon">
            {ribbonText}
          </span>
        }
        <div className="logo">
          <img src={orDefaultIconSrc(logoSrc)} />
        </div>
        <h3 className="title dsg-h3">{title}</h3>
        <div className="description">{description}</div>
        <div className="filler" />
        <div className="detail">
          {detailComponent}
        </div>
      </div>
    )
  }

  render() {
    const { path, hasAccess, gatedUrl, external, externalUrl } = this.props
    const IntegrationLinkType = hasAccess && external ? AnchorLink : hasAccess ? Link : AnchorLink
    const linkProps = hasAccess && external
      ? { url: externalUrl }
      : hasAccess ? { to: path } : { url: gatedUrl || '/settings/billing' }
    return (
      <IntegrationLinkType {...linkProps}>
        {this.renderDetails()}
      </IntegrationLinkType>
    )
  }
}

IntegrationCard.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  logoSrc: PropTypes.string,
  isActive: PropTypes.bool,
  path: PropTypes.string.isRequired,
  external: PropTypes.bool,
}

export default IntegrationCard



// WEBPACK FOOTER //
// ./src/scripts/components/Integration/components/IntegrationCard.js